import CustomStepper from "../stapper/CustomStapper";
import StepTwo from "../stapper/StepTwo";

export function EventPlayTime() {
    return <CustomStepper step={1}>
        <StepTwo />
    </CustomStepper>
}